import React from 'react';

import customClientConfig from '../../customClientConfig';

const hlxLogo = require('../../assets/logo-hlx.png');
const meiLogo = require('../../assets/logo-mei.png');
const scimedLogo = require('../../assets/logo-scimed.png');

const HeaderComponent = ({ company, tenant, suppressBanner }) => {
  const clientConfig = customClientConfig[tenant];

  if (!suppressBanner && clientConfig && clientConfig.headerBanner) {
    // <picture> lets the browser fetch only the matching banner (the mobile
    // <source> or the desktop <img> fallback) rather than downloading both.
    return (
      <picture>
        {clientConfig.headerBannerMobile && (
          <source media="(max-width: 768px)" srcSet={clientConfig.headerBannerMobile} />
        )}
        <img
          src={clientConfig.headerBanner}
          alt={clientConfig.headerBannerAlt || tenant}
          style={{ width: '100%', display: 'block', marginBottom: 20 }}
        />
      </picture>
    );
  }

  const getLogo = () => {
    if (clientConfig && clientConfig.customHeaderLogo) {
      return clientConfig.customHeaderLogo;
    }

    switch (company) {
      case 'hlx':
        return hlxLogo;
      case 'mei':
        return meiLogo;
      case 'scimed':
        return scimedLogo;
      default:
        return hlxLogo;
    }
  };

  const getHeaderTitle = () => {
    if (clientConfig && clientConfig.headerTitle) {
      return clientConfig.headerTitle;
    }
    return 'Event Registration';
  };

  return (
    <div className="header">
      <img className="header-logo" src={getLogo()} alt="Registration" />
      <div className="header-title">{getHeaderTitle()}</div>
    </div>
  );
};

export default HeaderComponent;
